import api from './api';

export interface PaymentItem {
  _id: string;
  Date: string;
  Title: string;
  Description: string;
  Payment: number;
  PaymentStatus: 'pending' | 'completed' | 'failed' | 'processing';
}

export interface GetPaymentsParams {
  page?: number;
  limit?: number;
}

export interface PaginationData {
  page: number;
  limit: number;
  total: number;
  pages: number;
}

export interface GetPaymentsResponse {
  statusCode: string;
  message: string;
  data: {
    data: PaymentItem[];
    pagination: PaginationData;
  };
}

class PaymentService {
  async getPayments(params: GetPaymentsParams = {}): Promise<GetPaymentsResponse> {
    const { page = 1, limit = 10 } = params;
    
    try {
      const response = await api.get(`/booking/payments`, {
        params: {
          page,
          limit
        }
      });
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Failed to fetch payments');
    }
  }
}

export const paymentService = new PaymentService();